import './analytics.js';
import { trackVideoProgress } from './video_track.js';
import { registerWithMist } from './register_with_mist.js';

document.addEventListener('DOMContentLoaded', () => {
    const video = document.getElementById('gate-video');
    const videoUrl = document.getElementById('videoConfig').dataset.url;
    const buttonContainer = document.getElementById('buttonContainer');
    const threshold = document.getElementById('videoConfig').dataset.duration;
    const buttonCopy = document.getElementById('pageConfig').dataset.buttoncopy;

    // fade the video in when enough has loaded to play
    video.addEventListener('canplay', () => {
        video.style.opacity = '1';
    });

    // start to track video progress once video is available
    video.addEventListener('loadedmetadata', () => {
        const progressHandler = () => trackVideoProgress(threshold, progressHandler, buttonCopy);
        video.addEventListener('timeupdate', progressHandler);
    });

    // listen for button click to connect to Mist
    buttonContainer.addEventListener('click', function(e) {
        if (e.target.id == "continue-btn"){
            registerWithMist();
        }
    });

    // initiate loading of video
    const url = new URL(videoUrl);
    const pathParts = url.pathname.slice(1).split('/');
    const bucket = pathParts.shift();
    const blob = pathParts.join('/');
    video.src = `/video?bucket=${encodeURIComponent(bucket)}&blob=${encodeURIComponent(blob)}`;
    video.load();
});